/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import Vue from "vue";
import ApexCharts from "apexcharts";
import { CountUp } from "countup.js";

window.ApexCharts = ApexCharts;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

import ListMagang from "./components/widget/ListMagang.vue";

const components = {
    ListMagang,
};

document.querySelectorAll("[data-component]").forEach((el) => {
    const componentName = el.dataset.component; // Get the component name from the data attribute
    const Component = components[componentName]; // Retrieve the component from the registry

    if (Component) {
        new Vue({
            render: (h) => h(Component),
        }).$mount(el); // Mount the component to the element
    }
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".counter-value[data-counter-up], .counter-value[data-counter-number]").forEach((el) => {
        // Prefer data-counter-up, fallback to data-counter-number
        const counterValue =
            parseFloat(el.getAttribute("data-counter-up")) ||
            parseFloat(el.getAttribute("data-counter-number"));

        if (isNaN(counterValue)) {
            console.warn(
                `Invalid counter value: ${el.getAttribute("data-counter-number")} or ${el.getAttribute("data-counter-up")}. Expected a number.`
            );
            return;
        }

        const counter = new CountUp(el, counterValue, {
            useEasing: true,
            useGrouping: true,
            separator: ",",
            decimal: ",",
        });
        counter.start();
    });
});
